<style>div.zoezi-workout-book-button > div:last-child {
	/* display: none; */
}
div.v-dialog__content > div > div.v-card > div.v-card__actions > div.fill-width > div:last-child {
	/* display: none; */
}
div.v-dialog__content > div > div.v-card > div.v-card__text > div.row > div.text-right.col.col-4 > div {
	/* display: none; */
}
div.v-application > div.v-menu__content > div.v-list > div.v-list-item:last-child:not(:has(button)) {
	/* display: none; */
}</style>
<template><span></span></template>
<script>export default {
    methods: {
    }
}</script>